import React, { useState } from "react";
import classes from "./BasicInfoMobile.module.css";
import { Tabs } from "../../../../../stories/Tabs/Tabs";
import { Input } from "../../../../../stories/Input/Input";
import { Button } from "../../../../../stories/Button/Button";
import { DropDown } from "../../../../../stories/DropDown/DropDown";
import { Container, Row, Col } from "react-bootstrap";
import Fonts from "../../../../../stories/assets/Fonts";
import Colors from "../../../../../stories/assets/Colors";
import { useHistory } from "react-router-dom";
import {
  cancelIcon,
  addicongray,
  ArrowUpRightBlue,
} from "../../../../../constant/imagePath";
import { TextArea } from "../../../../../stories/TextArea/TextArea";
import { PriceInput } from "../../../../../stories/PriceInput/PriceInput";
import { LinkButtonWithIcon } from "../../../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { setActiveTab } from "../../../../../store/Actions/commonAction";
import { useDispatch, useSelector } from "react-redux";
import { setPersonalData } from "../../../../../store/Actions/authAction";

const BasicInfoMobile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const activeTab = useSelector((state) => state?.commonReducer?.activeTab);
  const setLessonData = useSelector(
    (state) => state?.onBoardingReducer?.setLesson
  );
  const startWorkAndGetPaid = useSelector(
    (state) => state.onBoardingReducer.price
  );
  const setAvailabilityData = useSelector(
    (state) => state.onBoardingReducer.setAvailability
  );

  const [sportstype, setSportstype] = useState([
    { label: "Tennis", value: "Tennis" },
  ]);

  const [sessionPlan, setSessionPlan] = useState(
    setLessonData?.sessionPlan ? setLessonData?.sessionPlan : ""
  );
  const [priceForAnHour, setPriceForAnHour] = useState(
    startWorkAndGetPaid?.priceForAnHour
      ? startWorkAndGetPaid?.priceForAnHour
      : ""
  );
  const [breakBetween, setbreakBetween] = useState(
    setAvailabilityData?.breakBetween ? setAvailabilityData?.breakBetween : ""
  );
  const [intervalBetween, setIntervalBetween] = useState(
    setAvailabilityData?.intervalBetween
      ? setAvailabilityData?.intervalBetween
      : ""
  );

  function saveDataIntoRedux() {
    // For Session Plan
    dispatch(
      setPersonalData("set-lesson", {
        ...setLessonData,
        sessionPlan,
      })
    );
    // For Lesson Price
    dispatch(
      setPersonalData("price", { ...startWorkAndGetPaid, priceForAnHour })
    );
    // For Break in between lessons
    dispatch(
      setPersonalData("setAvailability", {
        ...setAvailabilityData,
        breakBetween,
        intervalBetween,
      })
    );
  }
  return (
    <div className={[classes.BasicInfoScreen].join(" ")}>
      <div className={[classes.mainheading, classes.mb32].join(" ")}>
        <img
          src={cancelIcon}
          className={[classes.crossimg]}
          alt="..."
          onClick={() => history.goBack()}
        />
        <p
          style={{ ...Fonts.b3, color: Colors.neutralShadesOfNero }}
          className={[classes.textcenter].join(" ")}
        >
          Edit Lesson Info
        </p>
      </div>

      <Container className={["p-0", classes.container].join(" ")}>
        <Row className={["g-0", classes.row].join(" ")}>
          <Col sm={12} className={[classes.mb32].join(" ")}>
            <Tabs
              tabsData={[
                { label: "Basic info", activeText: "basic-info" },
                { label: "What’s included", activeText: "whats-included" },
                { label: "Location", activeText: "location" },
              ]}
              state={{ label: activeTab }}
              setState={(item) => dispatch(setActiveTab(item?.activeText))}
              matchWithActiveText={true}
            />
          </Col>

          <Col sm={12} className={[classes.mb32].join(" ")}>
            <DropDown
              state={sportstype}
              setter={setSportstype}
              options={[]}
              label="Sport type"
              placeholder=""
            />
          </Col>

          <Col sm={12} className={[classes.mb56].join(" ")}>
            <TextArea
              state={sessionPlan}
              setter={setSessionPlan}
              label="Tell students about your session plan"
              placeholder="What will you cover in the lesson? What should students expect?"
            />
          </Col>

          <Col md={12} className={[classes.mb16].join(" ")}>
            <h6
              style={{
                ...Fonts.h6,
                color: Colors.neutralShadesOfNero,
                fontSize: "16px",
                lineHeight: "24px",
              }}
              className={[classes.mb16]}
            >
              Break in-between lessons
            </h6>
          </Col>

          <Col md={12} className={[classes.mb32].join(" ")}>
            <div className={[classes.breakinlessondiv].join(" ")}>
              <div>
                <p
                  style={{
                    ...Fonts.p1,
                    color: Colors.neutralShadesOfNero,
                  }}
                  className={[classes.mb8].join(" ")}
                >
                  How much time would you need for a break in-between lessons?
                </p>
              </div>
              <span className="position-relative">
                <Input
                  state={breakBetween}
                  label=""
                  setter={setbreakBetween}
                  customStyle={{ width: "100%" }}
                  type="number"
                  inputStyle={{ paddingRight: "45px" }}
                  placeholder=""
                />
                <span className={classes.postMinText}>min</span>
              </span>
            </div>
          </Col>

          <Col md={12}>
            <div className={[classes.breakinlessondiv].join(" ")}>
              <div>
                <p
                  style={{
                    ...Fonts.p1,
                    color: Colors.neutralShadesOfNero,
                  }}
                  className={[classes.mb8].join(" ")}
                >
                  You are available at multipe locations. How much time would
                  you like in-between lessons at different locations?
                </p>
              </div>
              <span className="position-relative">
                <Input
                  state={intervalBetween}
                  label=""
                  setter={setIntervalBetween}
                  customStyle={{ width: "100%" }}
                  inputStyle={{ paddingRight: "45px" }}
                  type="number"
                  placeholder=""
                />
                <span className={classes.postMinText}>min</span>
              </span>
            </div>
          </Col>

          <Col sm={12} className={[classes.mb8, classes.mt56].join(" ")}>
            <h6
              style={{
                ...Fonts.h6,
                color: Colors.neutralShadesOfNero,
                fontSize: "16px",
                lineHeight: "24px",
              }}
              className={[classes.mb24].join(" ")}
            >
              Set your lesson price
            </h6>
            <Row
              className={[
                classes.dflex,
                classes.aligncenter,
                "g-0",
                classes.mb16,
              ].join(" ")}
            >
              <Col xs={9} sm={10}>
                <Input
                  placeholder=""
                  customStyle={{ width: "100%" }}
                  type="number"
                  state={priceForAnHour}
                  setter={(e) => {
                    if (e.length < 5) {
                      setPriceForAnHour(e)
                    }
                  }}
                  label="Set the price for 1 hour lessons USD"
                />
              </Col>
              <Col xs={3} sm={2} className={[classes.mt20].join(" ")}>
                <span
                  style={{
                    ...Fonts.h6,
                    color: Colors.neutralShadesOfNero,
                    fontSize: "16px",
                    lineHeight: "24px",
                  }}
                  className={[classes.ml8].join(" ")}
                >
                  /1 hour
                </span>
              </Col>
            </Row>
            <div
              className={[classes.blackpricediv, classes.mb24].join(" ")}
              style={{ backgroundColor: Colors.neutralShadesOfNero }}
            >
              <div className={[classes.w128].join(" ")}>
                <p style={{ ...Fonts.h9, color: Colors.white }}>
                  Amount you’ll earn for 1 hour lessons
                </p>
              </div>
              <div>
                <p style={{ ...Fonts.h3, color: Colors.white }}>
                  ${priceForAnHour}
                </p>
              </div>
            </div>

            <p
              className={`${[classes.lytesnapCharges, classes.mb8].join(" ")}`}
              style={{ ...Fonts.b2, color: Colors.neutralShadesOfNero }}
            >
              Lytesnap charges 10%{" "}
              <span style={{ ...Fonts.b4 }}>of your listed lesson price</span>
            </p>
          </Col>

          <Col sm={12} className={[classes.mb40].join(" ")}>
            <LinkButtonWithIcon
              text={"System fee info"}
              rightIcon={ArrowUpRightBlue}
              primary={true}
              iconStyle={{ margin: "0px" }}
              customStyle={{
                ...Fonts.b2,
                fontSize: "14px",
                lineHeight: "16px",
              }}
            />
          </Col>

          <Col xs={12}>
            <Button
              customStyle={{ width: "100%", height: "56px" }}
              primary={true}
              size="Large"
              onClick={saveDataIntoRedux}
            >
              Save changes
            </Button>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
export default BasicInfoMobile;
